import React, { Component } from "react";
import HelperClass from "../../config/helperClass";
import {
  getSingleResellerInvoice,
  updateInvoice,
} from "../../config/reseller_api_calls";

const auth = new HelperClass();

function fmtCurrency(val, decimals) {
  const n = Number(val);
  if (!Number.isFinite(n)) return "$0.00";
  const fixed = n.toFixed(decimals || 2);
  const [intPart, decPart] = fixed.split(".");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return "$" + (decPart !== undefined ? withCommas + "." + decPart : withCommas);
}

function fmtDate(val) {
  if (!val) return "—";
  try {
    const d = new Date(val);
    if (isNaN(d.getTime())) return val;
    return `${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}-${d.getFullYear()}`;
  } catch { return val; }
}

function initState() {
  return {
    loading: false,
    loadError: "",
    submitting: false,
    error: "",
    success: "",
    invoiceNo: "",
    customerName: "",
    billingPeriod: "",
    fDueDate: "",
    fTaxTotal: "0",
    fShippingTotal: "0",
    _inv: null,
  };
}

class EditInvoiceModal extends Component {
  constructor(props) {
    super(props);
    this.state = initState();
    this._decimals = Number(auth.getBillingDecimalPoint() || 2);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show && this.props.invoice) {
      this.loadInvoice(this.props.invoice);
    }
    if (!this.props.show && prevProps.show) {
      this.setState(initState());
    }
  }

  loadInvoice = async (row) => {
    this.setState({ loading: true, loadError: "", error: "", success: "" });
    try {
      const response = await getSingleResellerInvoice(
        auth.getAccount(), auth.getToken(), row.invoice_no
      );
      const payload = response && response.data;
      if (payload && (payload.status === 403 || payload.errors === "authentication missing" || payload.errors === "jwt expired")) {
        auth.logout(); return;
      }
      if (payload && payload.status === 200 && payload.data) {
        const inv = payload.data.invoice || row;
        this.setState({
          loading: false,
          invoiceNo: inv.invoice_no || row.invoice_no || "",
          customerName: inv.customer_name || "",
          billingPeriod: inv.billing_period || "",
          fDueDate: (inv.due_date || "").slice(0, 10),
          fTaxTotal: String(Number(inv.tax_total) || 0),
          fShippingTotal: String(Number(inv.shipping_total) || 0),
          _inv: inv,
        });
      } else {
        this.setState({ loading: false, loadError: (payload && payload.message) || "Failed to load invoice." });
      }
    } catch {
      this.setState({ loading: false, loadError: "Failed to load invoice." });
    }
  };

  calcNewTotal() {
    const { _inv, fTaxTotal, fShippingTotal } = this.state;
    const inv = _inv || {};
    const subTotal  = Number(inv.sub_total)      || 0;
    const discount  = Number(inv.discount_total)  || 0;
    const origTax   = Number(inv.tax_total)       || 0;
    const origShip  = Number(inv.shipping_total)  || 0;
    const origGrand = Number(inv.grand_total)     || 0;
    const newTax    = Number(fTaxTotal)           || 0;
    const newShip   = Number(fShippingTotal)      || 0;
    const newGrand  = subTotal - discount + newTax + newShip;
    const taxDiff   = newTax  - origTax;
    const shipDiff  = newShip - origShip;
    return { origGrand, newGrand, subTotal, discount, origTax, origShip, newTax, newShip, taxDiff, shipDiff };
  }

  handleSubmit = async () => {
    const { invoiceNo, fDueDate, fTaxTotal, fShippingTotal, _inv } = this.state;
    if (!fDueDate) { this.setState({ error: "Due date is required." }); return; }

    const inv        = _inv || {};
    const subTotal   = Number(inv.sub_total)     || 0;
    const discount   = Number(inv.discount_total) || 0;
    const tax        = Number(fTaxTotal)          || 0;
    const ship       = Number(fShippingTotal)     || 0;
    const grand      = subTotal - discount + tax + ship;

    this.setState({ submitting: true, error: "", success: "" });
    try {
      const response = await updateInvoice(
        auth.getAccount(), auth.getToken(), invoiceNo,
        {
          due_date:        fDueDate,
          tax_total:       tax,
          shipping_total:  ship,
          grand_total:     grand,
          invoice_title:   inv.invoice_title   || "",
          customer_name:   inv.customer_name   || "",
          customer_email:  inv.customer_email  || "",
          payment_terms:   inv.payment_terms   || "Due on receipt",
          currency:        inv.currency        || "USD",
          notes:           inv.notes           || "",
          sub_total:       subTotal,
          discount_total:  discount,
        }
      );
      const payload = response && response.data;
      if (payload && (payload.status === 403 || payload.errors === "authentication missing")) { auth.logout(); return; }
      if (payload && payload.status === 200) {
        this.setState({ submitting: false, success: "Invoice updated successfully!" });
        setTimeout(() => { if (this.props.onSuccess) this.props.onSuccess(); }, 1000);
      } else {
        this.setState({ submitting: false, error: (payload && payload.message) || "Failed to update invoice." });
      }
    } catch {
      this.setState({ submitting: false, error: "Failed to update invoice." });
    }
  };

  render() {
    const { show, onClose } = this.props;
    if (!show) return null;

    const {
      loading, loadError, submitting, error, success,
      invoiceNo, customerName, billingPeriod,
      fDueDate, fTaxTotal, fShippingTotal, _inv,
    } = this.state;

    const d = this._decimals;
    const { origGrand, newGrand, subTotal, newTax, newShip, taxDiff, shipDiff } = this.calcNewTotal();
    const totalChanged = _inv && (newGrand !== origGrand);

    return (
      <div
        style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.62)", zIndex: 1055, display: "flex", alignItems: "flex-start", justifyContent: "center", overflowY: "auto", padding: "24px 16px" }}
        onClick={(e) => { if (e.target === e.currentTarget && !submitting) onClose && onClose(); }}
      >
        <div
          style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 500, boxShadow: "0 20px 60px rgba(0,0,0,0.22)", display: "flex", flexDirection: "column", overflow: "hidden", marginBottom: 24 }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* ── Header (ViewInvoiceModal style) ── */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 20px", background: "#fff", borderBottom: "1.5px solid #E8E4DF", flexWrap: "wrap" }}>
            <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <em className="icon ni ni-edit" style={{ fontSize: 15, color: "#1C5BDE" }}></em>
                <span style={{ fontSize: 16, fontWeight: 800, color: "#1A1917", letterSpacing: "-0.01em", lineHeight: 1.2 }}>
                  {invoiceNo || "Edit Invoice"}
                </span>
                <span style={{ padding: "2px 8px", background: "rgba(245,158,11,0.1)", color: "#D97706", borderRadius: 4, fontSize: 11, fontWeight: 700 }}>
                  Unpaid
                </span>
              </div>
            </div>
            <button
              onClick={() => !submitting && onClose && onClose()}
              disabled={submitting}
              style={{ width: 30, height: 30, borderRadius: 7, border: "1.5px solid #E0DDD8", background: "transparent", color: "#4D4944", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
            >
              ×
            </button>
          </div>

          {/* ── Body ── */}
          <div style={{ padding: "24px 24px 8px" }}>
            {loading ? (
              <div style={{ textAlign: "center", padding: "32px", color: "#6B6762" }}>
                <span className="spinner-border spinner-border-sm" />
                <span style={{ marginLeft: 8 }}>Loading…</span>
              </div>
            ) : loadError ? (
              <div style={errorBox}>{loadError}</div>
            ) : (
              <>
                {/* Fields */}
                <div style={{ marginBottom: 18 }}>
                  <label style={labelStyle}>Due Date <span style={{ color: "#DC2626" }}>*</span></label>
                  <input
                    style={inputStyle}
                    type="date"
                    value={fDueDate}
                    onChange={(e) => this.setState({ fDueDate: e.target.value })}
                    disabled={submitting}
                  />
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 22 }}>
                  <div>
                    <label style={labelStyle}>Tax ($)</label>
                    <input
                      style={inputStyle}
                      type="number"
                      min="0"
                      step="0.01"
                      value={fTaxTotal}
                      onChange={(e) => this.setState({ fTaxTotal: e.target.value })}
                      disabled={submitting}
                      placeholder="0.00"
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>Shipping ($)</label>
                    <input
                      style={inputStyle}
                      type="number"
                      min="0"
                      step="0.01"
                      value={fShippingTotal}
                      onChange={(e) => this.setState({ fShippingTotal: e.target.value })}
                      disabled={submitting}
                      placeholder="0.00"
                    />
                  </div>
                </div>

                {/* ── Grand Total Summary ── */}
                {_inv && (
                  <div style={{ background: "#F8F7F5", border: "1px solid #E8E4DF", borderRadius: 10, overflow: "hidden", marginBottom: 18 }}>
                    {/* section label */}
                    <div style={{ padding: "10px 16px", borderBottom: "1px solid #E8E4DF", fontSize: 10.5, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9A9690" }}>
                      Invoice Total Summary
                    </div>

                    <div style={{ padding: "14px 16px" }}>
                      {/* Breakdown rows */}
                      {[
                        { label: "Subtotal",  val: fmtCurrency(subTotal, d), muted: true },
                        { label: "Tax",       val: fmtCurrency(newTax, d),   diff: taxDiff  !== 0 ? taxDiff  : null },
                        { label: "Shipping",  val: fmtCurrency(newShip, d),  diff: shipDiff !== 0 ? shipDiff : null },
                      ].map(({ label, val, muted, diff }) => (
                        <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, fontSize: 13 }}>
                          <span style={{ color: muted ? "#9A9690" : "#4D4944" }}>{label}</span>
                          <span style={{ display: "flex", alignItems: "center", gap: 6, color: muted ? "#9A9690" : "#1A1917", fontWeight: muted ? 400 : 600 }}>
                            {val}
                            {diff != null && (
                              <span style={{ fontSize: 11, fontWeight: 700, padding: "1px 5px", borderRadius: 4, background: diff > 0 ? "rgba(220,38,38,0.08)" : "rgba(26,122,74,0.1)", color: diff > 0 ? "#DC2626" : "#1A7A4A" }}>
                                {diff > 0 ? `+${fmtCurrency(diff, d)}` : `-${fmtCurrency(Math.abs(diff), d)}`}
                              </span>
                            )}
                          </span>
                        </div>
                      ))}

                      {/* Divider */}
                      <div style={{ borderTop: "1.5px solid #E8E4DF", marginTop: 8, paddingTop: 10 }}>
                        {/* Previous total */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                          <span style={{ fontSize: 12, color: "#9A9690" }}>Previous Total</span>
                          <span style={{ fontSize: 13, color: "#9A9690", textDecoration: totalChanged ? "line-through" : "none" }}>
                            {fmtCurrency(origGrand, d)}
                          </span>
                        </div>
                        {/* New total */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: totalChanged ? "rgba(28,91,222,0.06)" : "transparent", borderRadius: 8, padding: "8px 10px", margin: "0 -4px" }}>
                          <span style={{ fontSize: 14, fontWeight: 800, color: "#1A1917" }}>
                            {totalChanged ? "Updated Total" : "Grand Total"}
                          </span>
                          <span style={{ fontSize: 18, fontWeight: 900, color: totalChanged ? "#1C5BDE" : "#1A1917", letterSpacing: "-0.02em" }}>
                            {fmtCurrency(newGrand, d)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {error && <div style={errorBox}>{error}</div>}
                {success && <div style={successBox}>{success}</div>}
              </>
            )}
          </div>

          {/* ── Footer ── */}
          {!loading && !loadError && (
            <div style={{ padding: "12px 24px 20px", display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button className="btn btn-light" onClick={() => onClose && onClose()} disabled={submitting}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={this.handleSubmit}
                disabled={submitting || !!success}
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                {submitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm" style={{ width: 14, height: 14, borderWidth: 2 }} />
                    Saving…
                  </>
                ) : (
                  <>
                    <em className="icon ni ni-check" style={{ fontSize: 15 }}></em>
                    Save Changes
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#312F2D",
  marginBottom: 7,
};

const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  border: "1px solid #DDD8D2",
  borderRadius: 8,
  fontSize: 14,
  color: "#1A1917",
  background: "#fff",
  outline: "none",
  boxSizing: "border-box",
};

const errorBox = {
  padding: "11px 14px",
  background: "#FEE2E2",
  borderRadius: 8,
  color: "#DC2626",
  fontSize: 13,
  marginBottom: 12,
};

const successBox = {
  padding: "11px 14px",
  background: "#D1FAE5",
  borderRadius: 8,
  color: "#065F46",
  fontSize: 13,
  marginBottom: 12,
};

export default EditInvoiceModal;
